module.exports = __webpack_public_path__ + "static/media/foto3.a6fed71d.png";